import { toast } from "react-toastify";
import {
  fetchCreatePriceBookRequest,
  fetchCreatePriceBookSuccess,
  fetchCreatePriceBookFailure,
} from "./reducer";

import { CREATE_PRICEBOOK } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const createPriceBook =
  (jsonObj, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchCreatePriceBookRequest());
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        CREATE_PRICEBOOK,
        "POST",
        jsonObj
      );

      if (response?.error) {
        dispatch(fetchCreatePriceBookFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchCreatePriceBookSuccess(response));
        dispatch(setSuccessMessage(true));

        toast.success("Price Book Created Successfully");

        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(fetchCreatePriceBookFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };